"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositGetDTO = exports.DepositOptions = exports.DepositFilter = exports.DepositUpdateDTO = exports.DepositCreateDTO = exports.DepositDTO = exports.PaymentOption = exports.DepositStatus = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const global_1 = require("../../../../global");
const lead_dto_1 = require("../../../lead/data/dto/lead_dto");
const models_1 = require("../../../models");
var DepositStatus;
(function (DepositStatus) {
    DepositStatus["PENDING"] = "pending";
    DepositStatus["COMPLETED"] = "completed";
    DepositStatus["FAILED"] = "failed";
})(DepositStatus = exports.DepositStatus || (exports.DepositStatus = {}));
var PaymentOption;
(function (PaymentOption) {
    PaymentOption["CASH"] = "cash";
    PaymentOption["BANK_TYPE_A"] = "bank-a";
    PaymentOption["BANK_TYPE_B"] = "bank-b";
})(PaymentOption = exports.PaymentOption || (exports.PaymentOption = {}));
class DepositDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(DepositDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], DepositDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DepositDTO.prototype, "stripePaymentIntentId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DepositDTO.prototype, "amount", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DepositDTO.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(DepositStatus),
    __metadata("design:type", String)
], DepositDTO.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DepositDTO.prototype, "isRefundable", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(PaymentOption),
    __metadata("design:type", String)
], DepositDTO.prototype, "paymentOption", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DepositDTO.prototype, "isRefunded", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => lead_dto_1.LeadDTO),
    __metadata("design:type", lead_dto_1.LeadDTO)
], DepositDTO.prototype, "lead", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => models_1.Vehicle),
    __metadata("design:type", models_1.Vehicle)
], DepositDTO.prototype, "vehicle", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], DepositDTO.prototype, "isDeleted", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Date)
], DepositDTO.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Date)
], DepositDTO.prototype, "updatedAt", void 0);
exports.DepositDTO = DepositDTO;
class DepositCreateDTO {
    constructor() {
        this.currency = "aed";
        this.status = DepositStatus.PENDING;
        this.isRefundable = false;
        this.isRefunded = false;
    }
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(DepositCreateDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DepositCreateDTO.prototype, "stripePaymentIntentId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DepositCreateDTO.prototype, "amount", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(PaymentOption),
    __metadata("design:type", String)
], DepositCreateDTO.prototype, "paymentOption", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DepositCreateDTO.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(DepositStatus),
    __metadata("design:type", String)
], DepositCreateDTO.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], DepositCreateDTO.prototype, "isRefundable", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], DepositCreateDTO.prototype, "isRefunded", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], DepositCreateDTO.prototype, "leadId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], DepositCreateDTO.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], DepositCreateDTO.prototype, "vehicleId", void 0);
exports.DepositCreateDTO = DepositCreateDTO;
class DepositUpdateDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(DepositUpdateDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(DepositStatus),
    __metadata("design:type", String)
], DepositUpdateDTO.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DepositUpdateDTO.prototype, "isRefundable", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DepositUpdateDTO.prototype, "isRefunded", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(PaymentOption),
    __metadata("design:type", String)
], DepositUpdateDTO.prototype, "paymentOption", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DepositUpdateDTO.prototype, "isDeleted", void 0);
exports.DepositUpdateDTO = DepositUpdateDTO;
class DepositFilter extends global_1.TypedFilter {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], DepositFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], DepositFilter.prototype, "stripePaymentIntentId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { each: true }),
    __metadata("design:type", Object)
], DepositFilter.prototype, "amount", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], DepositFilter.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(DepositStatus, { each: true }),
    __metadata("design:type", Object)
], DepositFilter.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DepositFilter.prototype, "isRefundable", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DepositFilter.prototype, "isRefunded", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], DepositFilter.prototype, "leadId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], DepositFilter.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], DepositFilter.prototype, "vehicleId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DepositFilter.prototype, "isDeleted", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DepositFilter.prototype, "search", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], DepositFilter.prototype, "fromDate", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], DepositFilter.prototype, "toDate", void 0);
exports.DepositFilter = DepositFilter;
class DepositOptions extends global_1.TypedOptions {
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(DepositOptions, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
exports.DepositOptions = DepositOptions;
class DepositGetDTO extends global_1.BaseGetDTO {
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(this, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DepositFilter),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", DepositFilter)
], DepositGetDTO.prototype, "filters", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => DepositOptions),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", DepositOptions)
], DepositGetDTO.prototype, "options", void 0);
exports.DepositGetDTO = DepositGetDTO;
